export function notNullValues<T extends Record<string, unknown>>(
  obj: T
): {[K in keyof T]: Exclude<T[K], null | undefined>} {
  const newObj = {} as any;
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== null && obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}
